export default () => {
    $( '.js-accordion-link' ).click( function ( e ) {
        e.preventDefault();
        // Hide all span
        const $this = $( this ).next( '.js-accordion-panel' );

        $( '.js-accordion-panel' ).not( $this ).slideUp( 'fast' );

        if ( !$( this ).parent().hasClass( 'is-active' ) ) {
            $( '.js-accordion-item' ).removeClass( 'is-active' );
            $( this ).parent().addClass( 'is-active' );
            $( this ).next( '.js-accordion-panel' ).slideDown( 'fast' );
        } else {
            $( this ).parent().removeClass( 'is-active' );
            $( this ).next( '.js-accordion-panel' ).slideUp( 'fast' );
        }
    } );
};
